import { render } from "./IconBot.vue?vue&type=template&id=4b9c2952"
const script = {}
script.render = render

export default script